import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HiUser, HiCode, HiBriefcase, HiFolder, HiMail } from 'react-icons/hi';

const StickyBar: React.FC = () => {
  const [activeSection, setActiveSection] = useState('');

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Track active section based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['about', 'skills', 'experience', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationItems = [
    { id: 'about', icon: HiUser, label: 'About' },
    { id: 'skills', icon: HiCode, label: 'Skills' },
    { id: 'experience', icon: HiBriefcase, label: 'Experience' },
    { id: 'projects', icon: HiFolder, label: 'Projects' },
    { id: 'contact', icon: HiMail, label: 'Contact' },
  ];

  return (
    <div className="fixed bottom-8 left-0 right-0 z-50 flex justify-center">
      <motion.nav
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="bg-neutral-800/20 backdrop-blur-[20px] block p-3 px-7 flex gap-3 rounded-full border border-neutral-700/30 shadow-lg"
      >
        {navigationItems.map((item) => (
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className={`bg-transparent p-4 rounded-full flex text-white text-xl transition-all duration-200 ${
              activeSection === item.id 
                ? 'bg-primary-500/40 text-white backdrop-blur-[10px]' 
                : 'hover:bg-accent-500/40 hover:backdrop-blur-[10px]'
            }`}
            title={item.label}
          >
            <item.icon size={20} />
          </button>
        ))}
      </motion.nav>
    </div>
  );
};

export default StickyBar; 